
import React, { useState, useEffect } from 'react';
import { default as API } from '../../../api/';
import IO from '../../../components/io';

const SignUp = ()=>{
  const [user_data, set_user_data] = useState({});
  const [server_error, set_server_error] = useState(null);

    const action = async () => {
     await API.trySignIn(user_data.email, user_data.password).catch(error => {
       let code = error.code;
       let message = error.message;
       if (code === 'auth/weak-password') {
         set_server_error({
           type: 'password',
           msg: message
         });
       } else if (code === 'auth/invalid-email') {
         set_server_error({
           type: 'email',
           msg: message
         });
       } else if (code === 'auth/email-already-in-use') {
         set_server_error({
           type: 'email',
           msg:
             'This email is on our records, if you need to recover your password tweet to @polmoneys for now please'
         });
       } else {
         set_server_error({
           type: 'unknown',
           msg: message
         });
       }
     });
    };

  const update = vals => set_user_data(vals);
    return (
          <IO.Form
        a11yTitle='Sign up form'
            report={vals => update(vals)}
            formId={'sign-up'}
            server={server_error}
            tracking={{
              email: '',
              password: ''
            }}>
            <IO.Email name='email' label='Email' autofocus />
            <br />
            <IO.Password name='password' label='Password' />
            <br />
            <IO.Button label={'CREATE USER'} onClick={action} />
          </IO.Form>
    );
    
    }

export default SignUp

